import React from 'react'
import * as styles from "../styles/upcoming.module.css"
import CarouselComponentUpcoming from './CarouselComponentUpcoming'
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { useBreakpoint } from 'gatsby-plugin-breakpoints';

export default function Upcoming() {
    const breakpoints = useBreakpoint();
    if (breakpoints.sm) {
        return (
            <section className={styles.upcomingMobile}>
                <div className={breakpoints.tablet ? styles.leftSideMobile2 : styles.leftSideMobile}>
                    <CarouselComponentUpcoming />
                </div>
                <div className={breakpoints.tablet ? styles.rightSideMobile2 : styles.rightSideMobile}>
                    <div className={styles.titleContainer}>
                        <h1>Upcoming Tournaments </h1>
                    </div>
                    <div className={styles.description}>
                        Our teams participate in a number of tournament in order to be the best in the region. Here you can find some of the tournaments our teams are participating in. We particpate in all tournaments ranging from Valorant to PUBGM, both in the Middle East, and in North African tournaments.
                    </div>
                </div>
            </section>
        )
    }
    else if (breakpoints.m) {
        return (
            <section className={styles.upcomingMobile}>
                <div className={breakpoints.tablet ? styles.leftSideMobile2 : styles.leftSideMobile}>
                    <CarouselComponentUpcoming />
                </div>
                <div className={styles.rightSideMobile}>
                    <div className={styles.titleContainer}>
                        <h1>Upcoming Tournaments </h1>
                    </div>
                    <div className={styles.description}>
                        Our teams participate in a number of tournament in order to be the best in the region. Here you can find some of the tournaments our teams are participating in. We particpate in all tournaments ranging from Valorant to PUBGM, both in the Middle East, and in North African tournaments.
                    </div>
                </div>
            </section>
        )
    }
    else {
        return (
            <section className={styles.upcoming}>
                <div className={styles.leftSide}>
                    <CarouselComponentUpcoming />
                </div>
                <div className={styles.rightSide}>
                    <div className={styles.titleContainer}>
                        <h1>Upcoming Tournaments</h1>
                    </div>
                    <div className={styles.description}>
                        Our teams participate in a number of tournament in order to be the best in the region. Here you can find some of the tournaments our teams are participating in. We particpate in all tournaments ranging from Valorant to PUBGM, both in the Middle East, and in North African tournaments.
                    </div>
                </div>
            </section>
        )
    }
}
